import { render, staticRenderFns } from "./productionCodeDetail.vue?vue&type=template&id=ab3846f8&scoped=true&"
import script from "./productionCodeDetail.vue?vue&type=script&lang=js&"
export * from "./productionCodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./productionCodeDetail.vue?vue&type=style&index=0&id=ab3846f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3846f8",
  null
  
)

export default component.exports